var map = {
	"./": 27690,
	"./en": 69644,
	"./en.js": 69644,
	"./es": 73990,
	"./es.js": 73990,
	"./index": 27690,
	"./index.js": 27690,
	"./traduccion.xlsx": 81944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37744;